import { orderService } from '@/services';
import { orderStatus } from '@/constants';
import DeliveryHistoryOrderVM from '@/view-model/delivery-history/DeliveryHistoryOrderVM';
import Order from '@/entity/Order';
import { calc } from './helper';
const action = {
    setFilterOption({ commit }, payload) {
        commit('SET_FILTER_OPTION', payload);
    },
    setSortOption({ commit }, payload) {
        commit('SET_SORT_OPTION', payload);
    },
    deleteOrder({ commit }, payload = {}) {
        const { orderId = 0 } = payload;
        commit('DELETE_ORDER', orderId);
    },
    resetDeliveryList({ commit }) {
        commit('RESET_DELIVERY_LIST');
    },
    cancelOrder({ commit }, orderId) {
        commit('CANCEL_ORDER', orderId);
    },
    async getOrder({ commit }, payload = {}) {
        const { orderId = 0 } = payload;
        const response = await orderService.getOrder({
            orderId,
        });
        commit('SET_ORDER', new Order(response.data));
    },
    /**
     * 배달 내역 호출
     */
    async getDeliveryHistory({ state: { filterOption, sortOption, }, getters, commit, rootGetters, }) {
        /**
         * 총판단위 조회는 hubIds를 넘기지 않는다.
         * 타허브권한이 없을 때 hubIds를 넘기면 에러가 난다.
         * 총판단위는 총판토큰을 이용해서 총판단위를 조회한다.
         * 타허브권한이 없으면 본인 토큰을 이용해서 본인 허브만 조회한다.
         * 타허브권한이 있으면 hubIds로 특정 허브를 조회한다.
         * hubIds로 조회하든 토큰으로 조회하든 결과는 같다.
         * https://barogo.slack.com/archives/C04UP4VFCKA/p1682580062423599
         */
        const isHubSelected = rootGetters['hubSelector/getterIsSubscribeHub'];
        const isPermissionOtherHub = rootGetters['user/isPermissionOtherHub'];
        const isDistUser = rootGetters['user/isDistUser'];
        let hubIds = rootGetters['hubSelector/getterSubscribeHubId'];
        // 총판계정 + 타허브조회권한 X + 타허브 선택 = 타허브 선택 (타허브 조회권한 무시)
        if (!isHubSelected || (!isPermissionOtherHub && !isDistUser)) {
            hubIds = null;
        }
        const { pageNumber, pageSize, statusCode, searchWord, hubType, payType, } = filterOption;
        const { field: searchType, value: searchText, } = searchWord;
        const [start, end,] = getters.getterBetweenDateToTimeStamp;
        // 종료일자 없으면 call x
        if (!end) {
            return false;
        }
        // 조회 기간
        const filterBetweenData = {
            field: 'orderedAt',
            start,
            end,
        };
        // 필터
        const filters = [];
        // 검색
        filters.push(...getters.getterSearchFieldTypeParam);
        // 발주유형
        filters.push(...getters.getterHubTypeParam);
        // 결제방법
        filters.push(...getters.getterPayTypeParam);
        // 접수타입(배달/퀵 서비스)
        filters.push(...getters.getterOrderTypeParam);
        const stCode = statusCode === orderStatus.ALL.code
            ? [
                orderStatus.DROP_FINISHED.code,
                orderStatus.CANCELED.code,
            ]
            : [
                statusCode,
            ];
        // 전체 카운트를 위한 더미 처리
        const stCodeForTotalCount = statusCode === orderStatus.ALL.code
            ? [
                orderStatus.DROP_FINISHED.code,
            ]
            : [
                orderStatus.DROP_FINISHED.code,
                orderStatus.CANCELED.code,
            ];
        try {
            const param = {
                hubIds,
                pageNumber,
                pageSize,
                statusCodes: stCode,
                betweenData: filterBetweenData,
                filters,
                sortOption,
                fromOrderedAt: filterBetweenData.start,
                toOrderedAt: filterBetweenData.end,
                orderOwnerType: hubType,
                searchPayType: payType,
                searchType,
                searchText,
            };
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const forTotalCountParam = {
                ...param,
                statusCodes: stCodeForTotalCount,
            };
            const data = await orderService.getDeliveryHistory(param);
            const { total, } = data.paginationData;
            const { totalCanceled, totalDropFinished, } = data.extraData;
            data.list = data.list.map((order) => new DeliveryHistoryOrderVM(order));
            commit('GET_DELIVERY_HISTORY_LIST', data);
            commit('GET_DELIVERY_HISTORY_COUNT_BACKUP_DATA', {
                total,
                totalCanceled,
                totalDropFinished,
            });
            return true;
        }
        catch (error) {
            console.log('[getDeliverHistory] ', error.message);
            return false;
        }
    },
    updateTotalCount({ state, commit, getters }) {
        const { filterOption: { statusCode, }, totalBackupData, } = state;
        const currentStatusCodeTotal = getters.getterCurrentStatusCodeTotal;
        commit('UPDATE_TOTAL_COUNT', calc[statusCode](currentStatusCodeTotal, totalBackupData));
    },
};
export default action;
